module.exports = __webpack_public_path__ + "img/upload-img-bg4.aadba9cd.png";